<div class="currency-list">
  <div class="currency-list__listbox">
    <lx-list-box (ngModelChange)="selectedCurrencyChanged.emit($event)" [(ngModel)]="currency" [options]="currencies" data-qa="currency-list">
      <ng-template #customItemTemplate let-priceCurrency pTemplate="priceCurrency">
        <div class="currency-list__listbox__option">
          <img
            [ngSrc]="'/assets/images/flags/' + (priceCurrency | lowercase | slice : 0 : 2) + '.png'"
            [alt]="priceCurrency"
            [height]="flagImageHeight"
            [width]="flagImageWidth"
          />
          <span>{{ priceCurrency }}</span>
        </div>
      </ng-template>
    </lx-list-box>
  </div>
</div>
